import React from 'react'
import { TableCell, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'

type DenseTableCellProps = {
  text?: string
  color?: string
  th?: boolean
  left?: boolean
}

export const DenseTableCell = ({
  text,
  color = grey[800],
  th = false,
  left = false,
  children
}: React.PropsWithChildren<DenseTableCellProps>) => {
  return (
    <TableCell
      sx={{
        py: '3px',
        px: '5px',
        borderBottom: th ? '1px solid #616161' : undefined,
        backgroundColor: th ? grey[50] : undefined
      }}>
      { text &&
        <Typography
          fontSize={11}
          whiteSpace={'pre'}
          color={color}
          textAlign={left ? 'left' : 'right'}
        >
          {text}
        </Typography> }
      { children }
    </TableCell>
  )
}
